{
  "media.title": "Medios",
  "media.empty": "No hay medios disponibles."
}
